import { render } from "./Tokenlogin.vue?vue&type=template&id=9c216e60&scoped=true"
import script from "./Tokenlogin.vue?vue&type=script&lang=js"
export * from "./Tokenlogin.vue?vue&type=script&lang=js"

import "./Tokenlogin.vue?vue&type=style&index=0&id=9c216e60&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c216e60"]])

export default __exports__